/**
 * Site-weite Anzeige reduzierter Preise bei aktivem prozentualem Rabattcode.
 *
 * Wenn im Warenkorb ein Rabattcode aktiv ist, der sich auf den GESAMTEN
 * Warenkorb auswirkt (value_type === 'percentage', target_selection === 'all'),
 * werden alle Produktpreise site-weit um diesen Prozentsatz reduziert
 * dargestellt: Original durchgestrichen (<del>) + reduzierter Preis (<ins>).
 *
 * Dies ist eine reine Anzeige-Schicht. Die tatsaechliche Rabattberechnung
 * bleibt bei Shopify/dem Warenkorb. Da Shopify prozentuale Bestellrabatte
 * gleichmaessig auf die Stueckpreise verteilt, entspricht der site-weit
 * angezeigte Preis exakt dem Stueckpreis im Warenkorb.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'sitewideDiscountPercent';
  var MANUAL_KEY = 'sitewideDiscountManual';
  var KNOWN_KEY = 'sitewideDiscountKnownCodes';
  var ATTR = 'data-sitewide-discount';
  var currentPercent = 0;
  var currentCode = null;

  /* ---------------------------------------------------------------------- *
   *  Money-Formatierung (Shopify-Standard-Algorithmus)
   * ---------------------------------------------------------------------- */
  function moneyFormat() {
    var s = (window.theme && window.theme.settings) || {};
    if (s.currency_code_enabled && s.money_format_with_currency) {
      return s.money_format_with_currency;
    }
    return s.money_format || s.money_with_currency_format || '{{amount}} €';
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '{{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var value = '';
    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.'); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'"); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  /* ---------------------------------------------------------------------- *
   *  Prozentsatz aus dem Warenkorb ableiten
   * ---------------------------------------------------------------------- */
  // Liefert { percent, code } des wirksamen prozentualen Bestellrabatts.
  function discountFromCart(cart) {
    if (!cart) return { percent: 0, code: null };
    var apps = cart.cart_level_discount_applications || [];
    var total = 0;
    var code = null;
    for (var i = 0; i < apps.length; i++) {
      var a = apps[i];
      if (!a) continue;
      if (a.type !== 'discount_code') continue;
      if (a.value_type !== 'percentage') continue;
      // Nur Codes, die auf den GESAMTEN Warenkorb wirken.
      if (a.target_selection && a.target_selection !== 'all') continue;
      var val = parseFloat(a.value);
      if (!isNaN(val)) {
        total += val;
        if (!code) code = a.title; // erster passender Code
        writeKnown(a.title, val); // fuer den Leerer-Warenkorb-Fall merken
      }
    }
    if (total < 0) total = 0;
    if (total > 100) total = 100;
    return { percent: total, code: total > 0 ? code : null };
  }

  /* ---------------------------------------------------------------------- *
   *  Merkliste CODE -> Prozent (localStorage)
   *
   *  Bei LEEREM Warenkorb liefert Shopify zu einem angewendeten Code nur
   *  {code, applicable:false} — ohne Wert; cart_level_discount_applications
   *  ist leer (am Live-Shop verifiziert). Der Prozentsatz ist also nur
   *  ableitbar, solange Artikel im Warenkorb liegen. Deshalb wird jeder
   *  einmal gesehene Wert je Code gemerkt und bei leerem Warenkorb wieder
   *  verwendet, solange der Code am Warenkorb haengt. Aendert der Shop den
   *  Wert eines Codes, korrigiert die naechste Sichtung mit Artikeln den
   *  Eintrag automatisch.
   * ---------------------------------------------------------------------- */
  function readKnown() {
    try {
      var obj = JSON.parse(localStorage.getItem(KNOWN_KEY));
      return obj && typeof obj === 'object' ? obj : {};
    } catch (e) {
      return {};
    }
  }

  function writeKnown(code, percent) {
    if (!code || !(percent > 0)) return;
    try {
      var map = readKnown();
      map[String(code).toUpperCase()] = percent;
      localStorage.setItem(KNOWN_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  // Leerer Warenkorb: Codes haengen ohne Wert am Warenkorb ({applicable:false}).
  // Referral-Links haengen ihren Code AN, statt zu ersetzen — angewendet wird
  // spaeter aber nur der zuletzt angehaengte (am Live-Shop verifiziert; cart-
  // discounts.js reduziert die Liste zusaetzlich aktiv auf diesen Code).
  // Deshalb zaehlt hier ausschliesslich der LETZTE Code — fruehere werden
  // ignoriert und Werte nie summiert.
  // Zuletzt angehaengter Code am (leeren) Warenkorb — der, der spaeter greift.
  function lastPendingCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = codes.length - 1; i >= 0; i--) {
      if (codes[i] && codes[i].code) return codes[i].code;
    }
    return null;
  }

  function knownFromEmptyCart(cart) {
    if (!cart || cart.item_count !== 0) return { percent: 0, code: null };
    var winner = lastPendingCode(cart);
    if (!winner) return { percent: 0, code: null };
    var val = readKnown()[String(winner).toUpperCase()];
    return val > 0 ? { percent: val, code: winner } : { percent: 0, code: null };
  }

  // Theme-Setting "Referral-Code Fallback-Rabatt": bewusste Hardcode-
  // Entscheidung (2026-08). Shopify verraet die Hoehe eines Codes erst, wenn
  // ein Artikel im Warenkorb liegt; fuer Referral-Erstbesucher mit leerem
  // Warenkorb zeigt dieser Wert die Preise vorab reduziert. Er wird im
  // Theme-Editor gepflegt und MUSS zu den verteilten Codes passen — sobald
  // Artikel im Warenkorb liegen, korrigiert der echte Wert die Anzeige.
  function fallbackPercent() {
    var s = (window.theme && window.theme.settings) || {};
    var raw = String(s.referral_discount_fallback_percent || '').replace(',', '.');
    var val = parseFloat(raw);
    return val > 0 && val < 100 ? val : 0;
  }

  function readCache() {
    try {
      var v = parseFloat(sessionStorage.getItem(STORAGE_KEY));
      return isNaN(v) ? 0 : v;
    } catch (e) {
      return 0;
    }
  }

  function writeCache(percent) {
    try { sessionStorage.setItem(STORAGE_KEY, String(percent)); } catch (e) {}
  }

  /* ---------------------------------------------------------------------- *
   *  Manueller Override (Quick-Apply bei leerem Warenkorb)
   *
   *  Wenn ein Code via /discount/CODE-Cookie vorgemerkt wurde (leerer
   *  Warenkorb kann ihn noch nicht validieren), zeigen wir die Preise schon
   *  reduziert an. Sobald der Warenkorb Artikel hat, ist der Warenkorb die
   *  Autoritaet und der Override wird verworfen.
   * ---------------------------------------------------------------------- */
  function readManual() {
    try {
      var raw = localStorage.getItem(MANUAL_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (obj && obj.code && obj.percent > 0) return obj;
      return null;
    } catch (e) {
      return null;
    }
  }

  function writeManual(obj) {
    try { localStorage.setItem(MANUAL_KEY, JSON.stringify(obj)); } catch (e) {}
  }

  function clearManual() {
    try { localStorage.removeItem(MANUAL_KEY); } catch (e) {}
  }

  // Effektiven Prozentsatz bestimmen: Warenkorb hat Vorrang. Bei leerem
  // Warenkorb greift der Override; sobald Artikel da sind, ist der Warenkorb
  // massgeblich und ein nicht (mehr) aktiver Override wird geloescht.
  function resolvePercent(cart) {
    var d = discountFromCart(cart);
    if (d.percent > 0) {
      clearManual();
      return d;
    }
    // Leerer Warenkorb mit angehaengtem Code: Wert aus der Merkliste.
    var known = knownFromEmptyCart(cart);
    if (known.percent > 0) {
      return known;
    }
    var manual = readManual();
    if (manual && cart && cart.item_count > 0) {
      clearManual();
      return { percent: 0, code: null };
    }
    // Haengt am leeren Warenkorb inzwischen ein ANDERER Code als der manuell
    // vorgemerkte (z. B. spaeterer Referral-Link), gewinnt der Cart-Code —
    // der veraltete Override wird verworfen.
    if (manual && cart && cart.item_count === 0) {
      var attached = lastPendingCode(cart);
      if (attached && manual.code &&
          String(attached).toUpperCase() !== String(manual.code).toUpperCase()) {
        clearManual();
        manual = null;
      }
    }
    if (manual) {
      return { percent: manual.percent, code: manual.code };
    }
    // Leerer Warenkorb, Code haengt an, Hoehe unbekannt -> Theme-Setting-
    // Fallback (Prioritaet: echter Cart-Wert > Merkliste > Manual > Fallback).
    // Wie in knownFromEmptyCart zaehlt nur der zuletzt angehaengte Code.
    if (cart && cart.item_count === 0) {
      var fb = fallbackPercent();
      if (fb > 0 && lastPendingCode(cart)) {
        return { percent: fb, code: lastPendingCode(cart) };
      }
    }
    return { percent: 0, code: null };
  }

  // Quick-Apply (leerer Warenkorb): Code vormerken + Preise sofort reduzieren.
  function setManual(code, percent) {
    percent = parseFloat(percent) || 0;
    if (!code || !(percent > 0)) return;
    writeManual({ code: code, percent: percent });
    setPercent(percent, code);
  }

  /* ---------------------------------------------------------------------- *
   *  Preis-Element umschreiben / zuruecksetzen
   * ---------------------------------------------------------------------- */
  function applyToElement(el) {
    if (!el) return;

    // Stufen-Elemente verwaltet discount-tiered.js — es rechnet einen aktiven
    // Code-Rabatt selbst multiplikativ auf den Stufenpreis. Hier anfassen
    // wuerde die Stufen-Anzeige mit einer Rechnung vom vollen Basispreis
    // ueberschreiben.
    if (el.hasAttribute && el.hasAttribute('data-tier-price')) return;

    var applied = el.getAttribute(ATTR);
    if (applied === String(currentPercent)) return; // bereits aktuell

    if (!(currentPercent > 0)) {
      // Nur zuruecksetzen, was dieses Script selbst umgeschrieben hat (ATTR
      // gesetzt). Frueher wurde hier bei Prozent 0 ungefragt ein Snapshot
      // angelegt und spaeter wiederhergestellt — das hat fremde Preis-Updates
      // (Stufen-Anzeige von discount-tiered.js) mit veraltetem Markup
      // ueberschrieben.
      if (applied != null && el.__sitewideOrig != null) {
        el.innerHTML = el.__sitewideOrig;
      }
      el.__sitewideOrig = null;
      el.removeAttribute(ATTR);
      return;
    }

    // Auf den Originalzustand zuruecksetzen, bevor (neu) angewendet wird;
    // Snapshot erst beim ersten tatsaechlichen Anwenden aufnehmen.
    if (el.__sitewideOrig != null) {
      el.innerHTML = el.__sitewideOrig;
    } else {
      el.__sitewideOrig = el.innerHTML;
    }

    var cents = parseInt(el.getAttribute('data-price'), 10);
    if (isNaN(cents) || cents <= 0) return;

    var ins = el.querySelector('ins');
    var amount = ins && ins.querySelector('.amount');
    if (!amount) return;

    var format = moneyFormat();
    // Shopify schneidet den Rabattbetrag auf ganze Cents ab (kein
    // kaufmaennisches Runden): 34,99 € bei 30% -> Rabatt 10,49 €, Preis
    // 24,50 €. Epsilon faengt Float-Drift knapp unter einer Cent-Grenze ab.
    var reduced = cents - Math.floor(cents * currentPercent / 100 + 1e-9);
    var origMoney = formatMoney(cents, format);
    var reducedMoney = formatMoney(reduced, format);
    var origText = amount.textContent;

    // Bereits im Sale (compare-at <del> vorhanden)? Dann nur <ins> reduzieren,
    // der bestehende Streichpreis bleibt Referenz. Sonst Original als <del>
    // davor einfuegen.
    if (!el.querySelector('del')) {
      var del = document.createElement('del');
      var delAmount = document.createElement('span');
      delAmount.className = 'amount';
      delAmount.textContent = origText;
      del.appendChild(delAmount);
      ins.parentNode.insertBefore(del, ins);
    }

    // Reduzierten Betrag setzen. "ab …"-Varianten (from_price_html) behalten
    // ihr Praefix, indem nur der Geldbetrag ersetzt wird.
    var newText = origText.indexOf(origMoney) !== -1
      ? origText.replace(origMoney, reducedMoney)
      : reducedMoney;
    amount.textContent = newText;
    if (amount.className.indexOf('discounted') === -1) {
      amount.className = (amount.className + ' discounted').trim();
    }

    el.setAttribute(ATTR, String(currentPercent));
  }

  function processAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.price[data-price]');
    for (var i = 0; i < nodes.length; i++) applyToElement(nodes[i]);
  }

  function setPercent(percent, code) {
    percent = percent || 0;
    code = percent > 0 ? (code || null) : null;
    var changed = percent !== currentPercent || code !== currentCode;
    currentPercent = percent;
    currentCode = code;
    writeCache(percent);
    processAll(document);
    if (changed) emitChanged();
  }

  // Signal fuer externe Verbraucher (z. B. eine Bundle-App), das bei JEDER
  // Aenderung des wirksamen Prozentsatzes/Codes feuert.
  function emitChanged() {
    document.dispatchEvent(new CustomEvent('sitewide-discount:changed', {
      detail: { percent: currentPercent, code: currentCode }
    }));
  }

  /* ---------------------------------------------------------------------- *
   *  Warenkorb laden (Autoritaet)
   * ---------------------------------------------------------------------- */
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var d = resolvePercent(cart);
        setPercent(d.percent, d.code);
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------------- *
   *  Dynamisch nachgeladene Inhalte beobachten
   * ---------------------------------------------------------------------- */
  function observe() {
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      if (!(currentPercent > 0)) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('.price[data-price]')) {
            applyToElement(node);
          }
          if (node.querySelectorAll) processAll(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------------------- *
   *  Init
   * ---------------------------------------------------------------------- */
  function init() {
    // 1) Gecachten Prozent sofort anwenden (minimiert Flicker). Faellt der
    //    Session-Cache aus (neuer Tab), greift ein evtl. vorgemerkter Override.
    var manual = readManual();
    var cached = readCache();
    var start = Math.max(cached, manual ? manual.percent : 0);
    if (start > 0) {
      currentPercent = start;
      currentCode = manual ? manual.code : null;
      processAll(document);
    }

    // 2) Warenkorb als Autoritaet nachladen und ggf. korrigieren.
    refresh();

    // 3) Reagieren auf Cart-/Rabatt-Aenderungen.
    // IMMER ueber /cart.js (Autoritaet) aktualisieren, NIE ueber das im Event
    // mitgelieferte Cart-Objekt: das stammt aus der POST-Antwort von
    // cart/update.js bzw. cart/change.js und enthaelt die
    // cart_level_discount_applications nicht zuverlaessig (am Live-Shop
    // verifiziert). Wuerde man ihm vertrauen, loest resolvePercent bei nicht-
    // leerem Warenkorb zu 0 auf und setPercent(0) entfernt site-weit alle
    // Streichpreise (Bug: Mengenaenderung/Entfernen im Drawer liess die
    // reduzierten Preise verschwinden). /cart.js ist derselbe Pfad wie beim
    // Seiten-Reload, der nachweislich funktioniert.
    document.addEventListener('discount:updated', refresh);
    document.addEventListener('line-item:change:end', refresh);
    document.addEventListener('cart:item-added', refresh);

    // Variantenwechsel rendert die Preis-Section neu -> erneut anwenden.
    document.addEventListener('product:variant-change', function () {
      // Auf den DOM-Austausch warten.
      setTimeout(function () { processAll(document); }, 0);
    });

    // 4) Nachgeladene Inhalte (Infinite-Scroll, Quick-View, Drawer, ...).
    observe();
  }

  // Oeffentliche API (Quick-Apply-Banner + externe Verbraucher wie eine
  // Bundle-App).
  window.SitewideDiscount = {
    refresh: refresh,
    getPercent: function () { return currentPercent; },
    getCode: function () { return currentCode; },
    getState: function () { return { percent: currentPercent, code: currentCode }; },
    setPercent: setPercent,
    setManual: setManual,
    getManual: readManual,
    clearManual: clearManual
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
